import React from 'react';

const EmergencyContactDetails = (props) => {
	const { onChangeHandler, SelectedFormState, interviewDetails, validationErrors } = props;

	return (
		<div>
			<div className="appDivider" />
			<h5 style={{ color: '#666' }} className="">
				Emergency Contact Details
			</h5>
			<div className="appDivider" />
			<div className='container'>
				<div className='row'>
					<div className='col-md-6'>
						<div className='container'>
							<div className="row">
								<div className="col-md-6 col-xs-12">
									<label className="appFormLabel">
										Name
									</label>
								</div>
								<div className="col-md-6 col-xs-12">
									<input
										className="form-control z-depth-3"
										onChange={onChangeHandler}
										value={SelectedFormState.EmgContactName}
										name="EmgContactName"
										type="text"
										maxLength="100"
										disabled={interviewDetails.editable === false ? true : false}
									/>
								</div>
							</div>
						</div>
					</div>
					<div className='col-md-6'>
						<div className='container'>
							<div className="row">
								<div className="col-md-6 col-xs-12">
									<label className="appFormLabel">
										Address
									</label>
								</div>
								<div className="col-md-6 col-xs-12 text-right">
									<textarea
										className="form-control z-depth-3 resizeTextArea"
										onChange={onChangeHandler}
										value={SelectedFormState.EmgContactAddress}
										name="EmgContactAddress"
										type="text"
										maxLength="100"
										disabled={interviewDetails.editable === false ? true : false}
									/>
									{SelectedFormState.EmgContactAddress.length} /100
								</div>
							</div>
						</div>
					</div>
					<div className='col-md-6'>
						<div className='container'>
							<div className="row">
								<div className="col-md-6 col-xs-12">
									<label className="appFormLabel">
										Relationship
									</label>
								</div>
								<div className="col-md-6 col-xs-12">
									<input
										className="form-control z-depth-3"
										onChange={onChangeHandler}
										value={SelectedFormState.EmgContactRelationship}
										name="EmgContactRelationship"
										type="text"
										maxLength="100"
										disabled={interviewDetails.editable === false ? true : false}
									/>
								</div>
							</div>
						</div>
					</div>
					<div className='col-md-6'>
						<div className='container'>
							<div className="row">
								<div className="col-md-6 col-xs-12">
									<label className="appFormLabel">
										Mobile No
									</label>
								</div>
								<div className="col-md-6 col-xs-12">
									<input
										className="form-control z-depth-3"
										onChange={onChangeHandler}
										value={SelectedFormState.EmgMobileNo}
										name="EmgMobileNo"
										type="text"
										maxLength="11"
										disabled={interviewDetails.editable === false ? true : false}
									/>
									{validationErrors.EmgMobileNoError ? (
										<p className="RoundValidationError">
											<i className="fa fa-warning warningIcon" />&nbsp; Please enter a valid a number
										</p>
									) : (
										''
									)}
								</div>
							</div>
						</div>
					</div>
					<div className='col-md-6'>
						<div className='container'>
							<div className="row">
								<div className="col-md-6 col-xs-12">
									<label className="appFormLabel">
										Phone No (Home)
									</label>
								</div>
								<div className="col-md-6 col-xs-12">
									<input
										className="form-control z-depth-3"
										onChange={onChangeHandler}
										value={SelectedFormState.EmgHomeContact}
										name="EmgHomeContact"
										type="text"
										maxLength="11"
										disabled={interviewDetails.editable === false ? true : false}
									/>
									{validationErrors.EmgHomeContactError ? (
										<p className="RoundValidationError">
											<i className="fa fa-warning warningIcon" />&nbsp; Please enter a valid number
										</p>
									) : (
										''
									)}
								</div>
							</div>
						</div>
					</div>
					<div className='col-md-6'>
						<div className='container'>
							<div className="row">
								<div className="col-md-6 col-xs-12">
									<label className="appFormLabel">
										Phone No (Work)
									</label>
								</div>
								<div className="col-md-6 col-xs-12">
									<input
										className="form-control z-depth-3"
										onChange={onChangeHandler}
										value={SelectedFormState.EmgWorkContact}
										name="EmgWorkContact"
										type="text"
										maxLength="11"
										disabled={interviewDetails.editable === false ? true : false}
									/>
									{validationErrors.EmgWorkContactError ? (
										<p className="RoundValidationError">
											<i className="fa fa-warning warningIcon" />&nbsp; Please enter a valid number
										</p>
									) : (
										''
									)}
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div >
	);
};

export default EmergencyContactDetails;
